export default __webpack_public_path__ + "static/media/proyecto2.a19081ec.jpg";